import ajax from './utils/ajax';

export default {
  profileProjects: '/',
  profilePackages: '/packages',
  url: ajax.getURL()
};
